import { inject } from '@angular/core'
import { Router } from '@angular/router'

import { OperatorDataState } from '@states/operator-data'

export const requireAuthGuard = () => {
	const router = inject(Router)
	const operatorDataState = inject(OperatorDataState)

	return operatorDataState.isAuthed() || router.createUrlTree(['/auth/sign-in'])
}
